module.exports = __webpack_public_path__ + "img/116.80c6a585.jpg";